import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const usePropertiesValues = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/Item/PropertyValueList", formData);
  });
  return mutation;
};
export default usePropertiesValues;
